import { Link } from 'app/components/ExternalLink';
import { RegionLink } from 'app/pages/Regions/RegionLink';
import { TFunction } from 'i18next';
import { translations } from 'locales/translations';
import { Column } from 'react-table';
import { GlobalSettings } from 'utils/globalSettings';
import { ISuperGroupDto } from '../ISuperGroupDto';

export const getColumns = (
  t: TFunction,
  settings: GlobalSettings,
  isAdmin: boolean,
) => {
  const cols: Column<ISuperGroupDto>[] = [
    {
      Header: t(translations.Id) as string,
      accessor: 'Id',
      Cell: ({ value, row }) => {
        if (isAdmin) {
          return (
            <>
              <Link
                href={`/newsupergroup.aspx?edit=${row.original.Id}`}
                target={'_blank'}
              >
                {value}
              </Link>
            </>
          );
        } else {
          return <>{value}</>;
        }
      },
    },
    {
      Header: t(translations.Name) as string,
      accessor: 'Name',
    },
    {
      Header: t(translations.RegionName) as string,
      accessor: 'RegionName',
      Cell: ({ value, row }) => {
        if (
          row.original.RegionId !== null &&
          row.original.RegionId !== undefined
        ) {
          return (
            <>
              {isAdmin ? (
                <RegionLink
                  id={row.original.RegionId}
                  initialModel={{
                    Id: row.original.RegionId,
                    Name: row.original.RegionName,
                  }}
                  useSidePanel={true}
                >
                  {value}
                </RegionLink>
              ) : (
                <>{value}</>
              )}
            </>
          );
        } else {
          return <>{'N/A'}</>;
        }
      },
    },
    {
      Header: t(translations.Description) as string,
      accessor: 'Description',
    },
  ];
  return cols;
};
